import { render, staticRenderFns } from "./UpdateFormPage.vue?vue&type=template&id=9ac6f402&scoped=true"
import script from "./UpdateFormPage.vue?vue&type=script&lang=js"
export * from "./UpdateFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac6f402",
  null
  
)

export default component.exports